import { useCallback, useEffect } from "react";
import { logInfo, logError } from "api/accounts-customer";
import { useSessionJWT } from "utils";

const PostedMessageLogger = () => {
  const { sessionJWT } = useSessionJWT();

  const messageListener = useCallback((message) => {
    const { source, sendToLogs, isError = false, payload = {} } = message?.data || {};
    if (source !== "widget-script" || !sendToLogs) return;
    if (isError) {
      logError(sessionJWT || {}, payload);
    } else {
      logInfo(sessionJWT || {}, payload);
    }
  }, [sessionJWT]);

  useEffect(() => {
    window.addEventListener("message", messageListener);
    return () => {
      window.removeEventListener("message", messageListener);
    };
  }, [messageListener]);

  return <></>;
};

export default PostedMessageLogger;